import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from 'src/app/helpers/must-match.validator';
import { AlertService } from 'src/app/services/alert/alert.service';
import { RecognitionsService } from 'src/app/services/recognitions/recognitions.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { RouterService } from 'src/app/services/router/router.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recognitions-form',
  templateUrl: './recognitions-form.page.html',
  styleUrls: ['./recognitions-form.page.scss'],
})
export class RecognitionsFormPage implements OnInit {
  recognitionForm: FormGroup;
  error = '';
  recognitions = [];
  collaborators = [];
  recognitionSelected;
  colaboratorSelected;
  image = '';
  userBy;
  isSaving = false;
  constructor(
    private formBuilder: FormBuilder,
    private recognitionsService: RecognitionsService,
    private remoteConfig: RemoteConfigService,
    private storageService: StorageService,
    private userService: UserService,
    private alertService: AlertService,
    private routerService: RouterService
  ) {
    this.initConstructor();
  }

  ionViewDidEnter() {
    this.recognitionForm.reset();
  }

  ngOnInit() {
    this.recognitionForm.reset();
    this.getImage();
    this.getRecognitionTypes();
    this.userService.getUserInfo().subscribe((res: any) => {
      if (res) {
        this.userBy = res;
      }
    });
  }

  initConstructor() {
    this.recognitionForm = this.formBuilder.group({
      recognition: [
        '',
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],
      collaboratorName: [
        '',
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],
      reason: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(140)]),
      ],
      inSocial: [false],
    });
  }

  getRecognitionTypes() {
    this.recognitionsService.getRecognitionsType().then((res: any) => {
      this.recognitions = res.data;
    });
  }

  colaboratorChanged(event, input) {
    let value = event.target.value;
    if (!this.recognitionSelected) {
      this.f.recognition.markAsTouched();
      input.value = '';
      return;
    }
    this.f.collaboratorName.setErrors({ incorrect: true });
    if (value.length > 2) {
      this.recognitionsService
        .getCollaborators(this.recognitionSelected.id, value)
        .then((res: any) => {
          this.collaborators = res.data;
        });
    }
  }

  collaboratorSelected(collaborator, input) {
    this.collaborators = [];
    this.colaboratorSelected = collaborator;
    input.value =
      collaborator.personal_data?.name +
      ' ' +
      collaborator.personal_data?.last_name;
    this.f.collaboratorName.setErrors(null);
  }

  clear(input) {
    input.value = '';
    this.f.collaboratorName.setErrors({ incorrect: true });
  }

  recognitionSelect(event) {
    this.recognitionSelected = event.target.value;
  }

  getImage() {
    this.remoteConfig.getImages().subscribe((res) => {
      this.image = res;
    });
  }

  async executeSave() {
    if (this.isSaving) return;
    this.isSaving = true;
    const recognition = this.recognitionSelected;
    const to = this.colaboratorSelected;
    const claims = await this.storageService.get('gnx-claims');
    const body = {
      appId: environment.gluky.app_id,
      type: {
        id: recognition.id,
        name: recognition.name,
        icon: {
          public_id: recognition.icon?.public_id,
          url: recognition.icon?.url,
          secure_url: recognition.icon?.secure_url,
        },
      },
      by: {
        uid: claims.uid,
        username: claims.username,
        names: this.userBy.name,
        last_names: this.userBy.lastnames,
      },
      to: {
        uid: to.id,
        username: to.personal_data.iddoc,
        names: to.personal_data.name,
        last_names: to.personal_data.last_name,
      },
      note: this.f.reason.value,
      datetime: new Date(),
      publish_in_wall: this.f.inSocial.value ? this.f.inSocial.value : false,
      viewed: false,
    };

    this.recognitionsService
      .grandRecognition(body)
      .then((res: any) => {
        if (res.created) {
          this.isSaving = false;
          this.recognitionForm.reset();
          this.routerService.redirect('app/recognitions-success');
        }
      })
      .catch((err) => {
        this.isSaving = false;
        switch (err) {
          case 'UNAUTHORIZED':
            this.alertService.presentAlert('Usuario no autorizado');
            break;
          case 'NOT_FOUND':
            this.alertService.presentAlert('No encontrado');
            break;
          case 'INTERNAL_SERVER_ERROR':
            this.alertService.presentAlert(
              'Error interno, comunicate con tu asesor'
            );
            break;
          default:
            this.alertService.presentAlert(err.error.message);
            break;
        }
      });
  }

  get f() {
    return this.recognitionForm.controls;
  }
}
